import Header from './../components/header/Header'

const Home = () => {
    return (
		<>
			<Header />
			<main className="section">
				<div className="container">
					<ul className="content-list">
						<li className="content-list__item">
							<h2 className="title-2">Automation & AI</h2>
							<p>
								n8n.io, Windmill, Playwright (Chromium),
								OpenAI, Google Gemini, xAI Grok (incl. Vision),
								Anthropic Claude, RAG, structured output with
								fallback chains
							</p>
						</li>
						<li className="content-list__item">
							<h2 className="title-2">Backend & Integrations</h2>
							<p>
								Python, FastAPI, Flask, pydantic, Node.js,
								Odoo (JSON-RPC), Bitrix24, VTEX, eBay, Mirakl,
								Metro DE, REST and webhook design
							</p>
						</li>
						<li className="content-list__item">
							<h2 className="title-2">Frontend</h2>
							<p>
								JavaScript, TypeScript, React.js, Redux, Angular,
								HTML, CSS, Sass, TailwindCSS, Material-UI,
								Bootstrap
							</p>
						</li>
						<li className="content-list__item">
							<h2 className="title-2">DevOps & Data</h2>
							<p>
								Docker, Coolify, Hetzner, Cloudflare,
								GitHub Actions, AWS (S3, CloudFront, IAM, Lambda),
								Supabase, MongoDB, SQL, Firebase, Airtable,
								Google Sheets API
							</p>
						</li>
					</ul>
				</div>
			</main>
		</>
	);
}

export default Home;
